module.exports = __webpack_public_path__ + "images/sys.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sys.png
// module id = 964
// module chunks = 2